import classNames from 'classnames';
import type { CSSProperties, ForwardedRef, ReactNode } from 'react';
import { forwardRef } from 'react';

import TextLink from '@/components/TextLink';
import { buildFlowFromPath } from '@/utils/analytics';
import InfoIcon from '@/ui-assets/icons/info-icon.svg?react';
import { trackEvent } from '@/utils/analytics';

import styles from './index.module.scss';

/* eslint-disable react/require-default-props */
type Props = {
  readonly className?: string;
  readonly message: ReactNode;
  readonly onClose: () => void;
  readonly style?: CSSProperties;
};
/* eslint-enable react/require-default-props */

const AppNotification = forwardRef(
  ({ className, message, style, onClose }: Props, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <div ref={ref} className={classNames(styles.notification, className)} style={style}>
        <InfoIcon className={styles.icon} />
        <div className={styles.message}>{message}</div>
        <TextLink
          text="action.got_it"
          className={styles.link}
          onClick={() => {
            const flow = buildFlowFromPath(window.location.pathname);
            trackEvent(
              'got_it_link',
              'clicked',
              { eventId: `${flow}_got_it_link_clicked` },
              {}
            );
            onClose();
          }}
        />
      </div>
    );
  }
);

export default AppNotification;
